import {
  clearToasts,
  showLoadingDoneToast,
  showLoadingToast,
} from 'Components/Generic/BOSToasterUtil';
import { useEffect, useState } from 'react';

const defaultInterval = 60 * 1000;
export const useAutoRefresh = (
  refreshDataFunc,
  refreshInterval = defaultInterval,
) => {
  const [autoRefresh, setAutoRefresh] = useState(0);
  const [timerID, setTimerID] = useState();

  useEffect(() => {
    return () => {
      clearTimer();
      clearToasts();
    };
  }, []);

  useEffect(() => {
    if (autoRefresh > 1) {
      showLoadingToast();
      refreshDataFunc();
    }
  }, [autoRefresh]);
  const startRefreshInterval = () => {
    if (autoRefresh && refreshInterval > 0) {
      autoRefresh > 1 && showLoadingDoneToast();
      let timerId = setTimeout(
        () => setAutoRefresh(autoRefresh + 1),
        refreshInterval,
      );
      setTimerID(timerId);
    }
  };
  const clearTimer = () => {
    timerID && clearTimeout(timerID);
    setTimerID(undefined);
  };

  const initiateAutoRefresh = () => {
    clearTimer();
    setAutoRefresh(1);
    refreshDataFunc();
  };

  const resetAutoRefresh = () => {
    clearTimer();
    setAutoRefresh(0);
  };

  let isInitialLoad = autoRefresh <= 1;

  return {
    initiateAutoRefresh,
    startRefreshInterval,
    resetAutoRefresh,
    isInitialLoad,
  };
};
